import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LogOut, Undo } from 'lucide-react'; // Importing Lucide React's LogOut icon
import { getAdminId } from '../../utils/tokenUtils';
import {
  AuthClient,
  AuthDTO,
  ImpersonationDTO,
} from '../../services/apiClient';
import { API_BASE_URL } from '../../config/config';
import axiosInstance from '../../services/axiosInstance';

const ProfileMenu: React.FC = () => {
  const navigate = useNavigate();
  const adminId = getAdminId();

  const impersonateClient = new AuthClient(API_BASE_URL, axiosInstance);

  const handleLogout = () => {
    // Remove token from localStorage (or any other storage you're using)
    localStorage.removeItem('token');
    localStorage.removeItem('refresh_token');

    // Navigate to login page
    navigate('/login');
  };

  const handleImpersonateLogout = async () => {
    const impersonateDto: ImpersonationDTO = {
      adminId: adminId ?? '',
    };

    try {
      const response =
        await impersonateClient.impersonateMemberLogout(impersonateDto);

      if (response && response.success && response.data) {
        const responseData = response.data as AuthDTO;

        localStorage.setItem('token', responseData.accessToken ?? '');
        localStorage.setItem('refresh_token', responseData.refreshToken ?? '');
        navigate('/admin/dashboard');
      }
    } catch (error) {
      console.error('Error impersonating login as member', error);
    }
  };

  return (
    <>
      <div className="absolute right-0 mt-2 w-48 bg-white border rounded-lg shadow-lg py-2 z-50">
        {adminId && (
          <button
            className="flex items-center gap-2 px-4 py-2 w-full text-left text-gray-700 hover:bg-gray-100 focus:outline-none"
            onClick={handleImpersonateLogout}
            aria-label="Return to admin"
          >
            <Undo className="w-5 h-5 text-gray-500" />
            <span>Return to Admin</span>
          </button>
        )}
        <button
          className="flex items-center gap-2 px-4 py-2 w-full text-left text-gray-700 hover:bg-gray-100 focus:outline-none"
          onClick={handleLogout}
          aria-label="Log out"
        >
          <LogOut className="w-5 h-5 text-gray-500" />
          <span>Log Out</span>
        </button>
      </div>
    </>
  );
};

export default ProfileMenu;
